import { axiosInstance } from '../utils/axios';

import { contentType, requestHeaders } from '../constants/requestHeaders';

export const getUser = ({ userId }, extraData) =>
  axiosInstance.get(`/users/${userId}`, {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const getHoveredUser = (
  { userId, orgId, streamId, channelId },
  extraData,
) =>
  axiosInstance.get(`/users/${userId}/hovercard`, {
    ...extraData,
    params: {
      ...extraData?.params,
      orgId,
      streamId,
      channelId,
    },
  });

export const getMe = extraData =>
  axiosInstance.get('/users/me', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const getUserChannels = extraData =>
  axiosInstance.get('/users/me/channels', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const getUserStreams = extraData =>
  axiosInstance.get('/users/me/streams', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const getUserOrgs = extraData =>
  axiosInstance.get('/users/me/orgs', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const getFavoriteBreadcrumbs = extraData =>
  axiosInstance.get('/users/me/favorites', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const postFavoriteBreadcrumbs = (data, extraData) =>
  axiosInstance.post('/users/me/favorites', data, extraData);

export const deleteFavoriteBreadcrumbs = (data, extraData) =>
  axiosInstance.delete('/users/me/favorites', { data, ...extraData });

export const postProfileImage = (formData, extraData) =>
  axiosInstance.post('users/me/picture', formData, {
    ...extraData,
    headers: requestHeaders.contentType(contentType.multipartFormData),
  });

export const addUserPaymentCard = extraData =>
  axiosInstance.post('users/me', null, {
    ...extraData,
    params: {
      ...extraData?.params,
      method: 'payment.add',
    },
  });
